import type { Translations } from '../../types'

const securityMessages: Translations = {
  "security.sessions.unknownDevice": "Dispositivo sconosciuto",
  "security.sessions.loadError": "Impossibile caricare le sessioni.",
  "security.sessions.loginRequired": "Esegui il login per gestire le sessioni.",
  "security.sessions.trustError": "Impossibile contrassegnare la sessione come fidata.",
  "security.sessions.trusted": "Sessione contrassegnata come dispositivo fidato.",
  "security.sessions.updateError": "Errore aggiornamento sessione.",
  "security.sessions.revokeError": "Impossibile revocare la sessione.",
  "security.sessions.revoked": "Sessione revocata.",
  "security.team.userDefault": "utente",
  "security.team.displayFallback": "Admin",
  "security.team.loadError": "Impossibile caricare il team.",
  "security.team.loginRequired": "Esegui il login per gestire il team.",
  "security.team.createError": "Impossibile creare l’utente.",
  "security.team.userCreated": "Nuovo membro creato.",
  "security.team.created": "Nuovo membro creato.",
  "security.team.updateUserError": "Impossibile aggiornare il membro.",
  "security.team.userUpdated": "Membro aggiornato.",
  "security.team.updateError": "Errore aggiornamento membro.",
  "security.team.userDeleted": "Membro eliminato.",
  "security.team.deleteError": "Errore eliminazione membro.",
  "security.team.rolesUpdated": "Ruoli aggiornati.",
  "security.team.rolesError": "Errore aggiornamento ruoli.",
  "security.team.createRoleError": "Impossibile creare il ruolo.",
  "security.team.roleCreated": "Ruolo creato."
}

export default securityMessages
